var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "occasion-shop", class: _vm.occasion }, [
    _c("div", { staticClass: "header" }, [
      _c("picture", [
        _c("source", {
          attrs: {
            media: "(max-width: 767px)",
            srcset: _vm.headers[1] ? _vm.headers[1] : _vm.headers[0]
          }
        }),
        _vm._v(" "),
        _c("img", { staticClass: "main-image", attrs: { src: _vm.headers[0] } })
      ]),
      _vm._v(" "),
      _vm.headers.length > 0
        ? _c("img", { staticClass: "main-image" })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "text-container", class: _vm.occasion }, [
        _c("h2", [
          _vm._v(
            _vm._s(_vm.occasion) +
              _vm._s(_vm.occasion.includes("Employee") ? " Day" : "") +
              " Gifts"
          )
        ])
      ]),
      _vm._v(" "),
      _vm.occasion.includes("Employee")
        ? _c("img", {
            staticClass: "spike",
            attrs: {
              src:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/march7.svg?v=1736961201"
            }
          })
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "top-section" }, [
      _c(
        "section",
        { staticClass: "adventure-section" },
        [
          _vm.waysImages.length < 4
            ? _c("p", { staticClass: "main-title" }, [
                _vm._v("Three ways to shop "),
                _c("br", { staticClass: "mobile" }),
                _vm._v(" for "),
                _c("span", [_vm._v(_vm._s(_vm.occasion))])
              ])
            : _c("p", { staticClass: "main-title" }, [
                _vm._v("Ways to "),
                _c("br", { staticClass: "mobile" }),
                _vm._v(" shop for "),
                _c("span", [_vm._v(_vm._s(_vm.occasion))])
              ]),
          _vm._v(" "),
          _c(
            "Flicking",
            {
              ref: "waysFlick",
              staticClass: "adventures-wrapper mobile",
              class: _vm.waysImages.length > 3 ? "small" : "",
              attrs: {
                plugins: _vm.plugins2,
                options: {
                  align: "center",
                  circular: true,
                  preventDefaultOnDrag: true,
                  preventClickOnDrag: true,
                  panelsPerView: 1.5
                }
              },
              on: {
                "will-change": function($event) {
                  return _vm.change($event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "adventure",
                  class: _vm.selectedAdventure == 0 ? "selected" : "",
                  on: {
                    click: function($event) {
                      return _vm.selectAdventure(0)
                    }
                  }
                },
                [
                  _vm.waysImages.length > 2
                    ? _c("div", { staticClass: "image-wrapper" }, [
                        _c("img", {
                          staticClass: "main-image",
                          attrs: {
                            height: "200",
                            width: "200",
                            src: _vm.waysImages[0],
                            alt: "ready to ship"
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-wrapper" }, [
                    _c("p", { staticClass: "title" }, [
                      _vm._v("Curated Gift Sets")
                    ]),
                    _vm._v(" "),
                    _vm.waysImages.length > 3
                      ? _c("p", { staticClass: "subtitle" }, [
                          _vm._v("Unwrap joy with our expertly "),
                          _c("br", { staticClass: "mobile" }),
                          _vm._v(" curated holiday gifts!")
                        ])
                      : _c("p", { staticClass: "subtitle" }, [
                          _vm._v(
                            "Expertly curated trending gifts, ready to send"
                          )
                        ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "happybox-button white border desktop",
                        attrs: {
                          href: "/pages/ready-to-ship?occasion=" + _vm.occasion
                        }
                      },
                      [_vm._v("Shop")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "legend mobile",
                        attrs: {
                          href: "/pages/ready-to-ship?occasion=" + _vm.occasion
                        }
                      },
                      [_vm._v("Shop >")]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "adventure",
                  class: _vm.selectedAdventure == 1 ? "selected" : "",
                  on: {
                    click: function($event) {
                      return _vm.selectAdventure(1)
                    }
                  }
                },
                [
                  _vm.waysImages.length > 2
                    ? _c("div", { staticClass: "image-wrapper" }, [
                        _c("img", {
                          staticClass: "main-image",
                          attrs: {
                            height: "200",
                            width: "200",
                            src: _vm.waysImages[1],
                            alt: "build a box"
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-wrapper" }, [
                    _c("p", { staticClass: "title" }, [
                      _vm._v("Build a Gift Box")
                    ]),
                    _vm._v(" "),
                    _vm.waysImages.length > 3
                      ? _c("p", { staticClass: "subtitle" }, [
                          _vm._v(
                            "Build a custom holiday gift box with all of their favorite things!"
                          )
                        ])
                      : _c("p", { staticClass: "subtitle" }, [
                          _vm._v(
                            "Pick from hundreds of items to build a gift that’s uniquely theirs"
                          )
                        ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "happybox-button white border desktop",
                        attrs: {
                          href: "/products/build-a-box?occasion=" + _vm.occasion
                        }
                      },
                      [_vm._v("Start Building")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "legend mobile",
                        attrs: {
                          href: "/products/build-a-box?occasion=" + _vm.occasion
                        }
                      },
                      [_vm._v("Start Building >")]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "adventure",
                  class: _vm.selectedAdventure == 2 ? "selected" : "",
                  on: {
                    click: function($event) {
                      return _vm.selectAdventure(2)
                    }
                  }
                },
                [
                  _vm.waysImages.length > 2
                    ? _c("div", { staticClass: "image-wrapper" }, [
                        _c("img", {
                          staticClass: "main-image goc",
                          class: _vm.occasion,
                          attrs: {
                            height: "200",
                            width: "200",
                            src: _vm.waysImages[2],
                            alt: "gift of choice"
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-wrapper" }, [
                    _c("p", { staticClass: "title" }, [
                      _vm._v("Gift of Choice")
                    ]),
                    _vm._v(" "),
                    _vm.waysImages.length > 3
                      ? _c("p", { staticClass: "subtitle" }, [
                          _vm._v(
                            "Let them choose their own gift from our festive holiday collection!"
                          )
                        ])
                      : _c("p", { staticClass: "subtitle" }, [
                          _vm._v("You pick your budget, they pick their gift")
                        ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "happybox-button white border desktop",
                        attrs: {
                          href: "/pages/gift-of-choice?occasion=" + _vm.occasion
                        }
                      },
                      [_vm._v("Get Started")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "legend mobile",
                        attrs: {
                          href: "/pages/gift-of-choice?occasion=" + _vm.occasion
                        }
                      },
                      [_vm._v("Get Started >")]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.waysImages.length > 3
                ? _c(
                    "div",
                    {
                      staticClass: "adventure",
                      class: _vm.selectedAdventure == 3 ? "selected" : "",
                      on: {
                        click: function($event) {
                          return _vm.selectAdventure(3)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "image-wrapper" }, [
                        _c("img", {
                          staticClass: "main-image bulk",
                          class: _vm.occasion,
                          attrs: {
                            height: "200",
                            width: "200",
                            src: _vm.waysImages[3],
                            alt: "gift of choice"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-wrapper" }, [
                        _c("p", { staticClass: "title" }, [
                          _vm._v("Bulk Custom Gifting")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "subtitle" }, [
                          _vm._v(
                            "Out experts will design & ship 100% custom gifts & packaging with your branding"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "happybox-button white border desktop",
                            attrs: {
                              href: "/pages/submit-an-inquiry-concierge-gifting"
                            }
                          },
                          [_vm._v("Request a Custom Proposal")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "legend mobile",
                            attrs: {
                              href: "/pages/submit-an-inquiry-concierge-gifting"
                            }
                          },
                          [_vm._v("Request a Custom Proposal >")]
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "adventures-wrapper desktop",
              class: _vm.waysImages.length > 3 ? "small" : "",
              attrs: { id: "aWrap" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "adventure",
                  class: _vm.selectedAdventure == 0 ? "selected" : "",
                  on: {
                    click: function($event) {
                      return _vm.selectAdventure(0)
                    }
                  }
                },
                [
                  _vm.waysImages.length > 2
                    ? _c("div", { staticClass: "image-wrapper" }, [
                        _c("img", {
                          staticClass: "main-image",
                          attrs: {
                            height: "200",
                            width: "200",
                            src: _vm.waysImages[0],
                            alt: "ready to ship"
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-wrapper" }, [
                    _c("p", { staticClass: "title" }, [
                      _vm._v("Curated Gift Sets")
                    ]),
                    _vm._v(" "),
                    _vm.waysImages.length > 3
                      ? _c("p", { staticClass: "subtitle" }, [
                          _vm._v(
                            "Unwrap joy with our expertly curated holiday gifts!"
                          )
                        ])
                      : _c("p", { staticClass: "subtitle" }, [
                          _vm._v(
                            "Expertly curated trending gifts, ready to send"
                          )
                        ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "happybox-button white border desktop",
                        attrs: {
                          href: "/pages/ready-to-ship?occasion=" + _vm.occasion
                        }
                      },
                      [_vm._v("Shop")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "legend mobile",
                        attrs: {
                          href: "/pages/ready-to-ship?occasion=" + _vm.occasion
                        }
                      },
                      [_vm._v("Shop >")]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "adventure",
                  class: _vm.selectedAdventure == 1 ? "selected" : "",
                  on: {
                    click: function($event) {
                      return _vm.selectAdventure(1)
                    }
                  }
                },
                [
                  _vm.waysImages.length > 2
                    ? _c("div", { staticClass: "image-wrapper" }, [
                        _c("img", {
                          staticClass: "main-image",
                          attrs: {
                            height: "200",
                            width: "200",
                            src: _vm.waysImages[1],
                            alt: "build a box"
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-wrapper" }, [
                    _c("p", { staticClass: "title" }, [
                      _vm._v("Build a Gift Box")
                    ]),
                    _vm._v(" "),
                    _vm.waysImages.length > 3
                      ? _c("p", { staticClass: "subtitle" }, [
                          _vm._v(
                            "Build a custom holiday gift box with all of their favorite things!"
                          )
                        ])
                      : _c("p", { staticClass: "subtitle" }, [
                          _vm._v(
                            "Pick from hundreds of items to build a gift that’s uniquely theirs"
                          )
                        ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "happybox-button white border desktop",
                        attrs: {
                          href: "/products/build-a-box?occasion=" + _vm.occasion
                        }
                      },
                      [_vm._v("Start Building")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "legend mobile",
                        attrs: {
                          href: "/products/build-a-box?occasion=" + _vm.occasion
                        }
                      },
                      [_vm._v("Start Building >")]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "adventure",
                  class: _vm.selectedAdventure == 2 ? "selected" : "",
                  on: {
                    click: function($event) {
                      return _vm.selectAdventure(2)
                    }
                  }
                },
                [
                  _vm.waysImages.length > 2
                    ? _c("div", { staticClass: "image-wrapper" }, [
                        _c("img", {
                          staticClass: "main-image goc",
                          class: _vm.occasion,
                          attrs: {
                            height: "200",
                            width: "200",
                            src: _vm.waysImages[2],
                            alt: "gift of choice"
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-wrapper" }, [
                    _c("p", { staticClass: "title" }, [
                      _vm._v("Gift of Choice")
                    ]),
                    _vm._v(" "),
                    _vm.waysImages.length > 3
                      ? _c("p", { staticClass: "subtitle" }, [
                          _vm._v(
                            "Let them choose their own gift from our festive holiday collection!"
                          )
                        ])
                      : _c("p", { staticClass: "subtitle" }, [
                          _vm._v("You pick your budget, they pick their gift")
                        ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "happybox-button white border desktop",
                        attrs: {
                          href: "/pages/gift-of-choice?occasion=" + _vm.occasion
                        }
                      },
                      [_vm._v("Get Started")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "legend mobile",
                        attrs: {
                          href: "/pages/gift-of-choice?occasion=" + _vm.occasion
                        }
                      },
                      [_vm._v("Get Started >")]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.waysImages.length > 3
                ? _c(
                    "div",
                    {
                      staticClass: "adventure",
                      class: _vm.selectedAdventure == 3 ? "selected" : "",
                      on: {
                        click: function($event) {
                          return _vm.selectAdventure(3)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "image-wrapper" }, [
                        _c("img", {
                          staticClass: "main-image bulk",
                          class: _vm.occasion,
                          attrs: {
                            height: "200",
                            width: "200",
                            src: _vm.waysImages[3],
                            alt: "gift of choice"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm._m(0)
                    ]
                  )
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("section", { staticClass: "rts-section" }, [
        _c("div", { staticClass: "normal-container" }, [
          _c("div", { staticClass: "title-header" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "arrows-container" }, [
              _c("img", {
                staticClass: "l-arrow",
                attrs: {
                  src:
                    "https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546",
                  alt: "left arrow"
                },
                on: {
                  click: function($event) {
                    return _vm.$refs.rts.prev()
                  }
                }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "r-arrow",
                attrs: {
                  src:
                    "https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546",
                  alt: "right arrow"
                },
                on: {
                  click: function($event) {
                    return _vm.$refs.rts.next()
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _vm.rtsProducts.length == 0
            ? _c(
                "div",
                { staticClass: "collections-container" },
                _vm._l(_vm.skeletons, function(n) {
                  return _c("SkeletonPlaceholder", { key: n })
                }),
                1
              )
            : _c(
                "div",
                { staticClass: "collections-container" },
                [
                  _c(
                    "Flicking",
                    {
                      ref: "rts",
                      staticClass: "flicking-goc-collection",
                      attrs: {
                        plugins: _vm.plugins1,
                        options: {
                          align: "prev",
                          circular: true,
                          preventDefaultOnDrag: true,
                          preventClickOnDrag: true,
                          panelsPerView: _vm.panels
                        }
                      }
                    },
                    _vm._l(_vm.rtsProducts, function(product) {
                      return _c(
                        "a",
                        {
                          key: product.id,
                          staticClass: "ready-product",
                          attrs: {
                            target: "_blank",
                            href:
                              "https://happyboxstore.com/products/" +
                              product.handle
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              loading: "lazy",
                              src: _vm._f("getProductImage")(product),
                              alt: product.title
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            { staticClass: "happybox-button white border" },
                            [_vm._v(_vm._s(product.title))]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ],
                1
              ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "happybox-button white border",
              attrs: { href: "/pages/ready-to-ship?occasion=" + _vm.occasion }
            },
            [_vm._v("Shop All")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "builder-section" }, [
        _c("div", { staticClass: "normal-container" }, [
          _vm._m(2),
          _vm._v(" "),
          _vm.filteredAddons.length == 0
            ? _c(
                "div",
                { staticClass: "collections-container" },
                _vm._l(_vm.builderSkeletons, function(n) {
                  return _c("SkeletonPlaceholder", { key: n })
                }),
                1
              )
            : _c(
                "div",
                { staticClass: "collections-container wrap" },
                _vm._l(_vm.filteredAddons, function(product) {
                  return _c("AddonProduct", {
                    key: product.id,
                    attrs: { occasion: _vm.occasion, product: product }
                  })
                }),
                1
              ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "happybox-button white border",
              attrs: { href: "/products/build-a-box?occasion=" + _vm.occasion }
            },
            [_vm._v("Build a Gift Box")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "goc-section" }, [
        _c("div", { staticClass: "normal-container" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("picture", { on: { click: _vm.goToGOC } }, [
            _c("source", {
              attrs: {
                media: "(max-width: 767px)",
                srcset: _vm.gocImage[1] ? _vm.gocImage[1] : _vm.gocImage[0]
              }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "goc-image",
              attrs: { src: _vm.gocImage[0] }
            })
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "happybox-button white border mobile",
              attrs: { href: "/pages/gift-of-choice?occasion=" + _vm.occasion }
            },
            [_vm._v("Get Started")]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "section",
        [
          !_vm.slides || _vm.slides.length == 0
            ? _c("Carousel")
            : _c("ContentCarousel", { attrs: { slides: _vm.slides } })
        ],
        1
      ),
      _vm._v(" "),
      _c("section", { staticClass: "looking-for" }, [
        _c("p", [
          _vm._v("Looking for custom "),
          _c("br", { staticClass: "mobile" }),
          _vm._v(" " + _vm._s(_vm.occasion) + " gifts for "),
          _c("br", { staticClass: "mobile" }),
          _vm._v(" your company? "),
          _c("br", { staticClass: "mobile" }),
          _vm._v(" We do that too.")
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "happybox-button green border",
            attrs: {
              target: "_blank",
              href: "https://meetings.hubspot.com/corporate-gifting"
            }
          },
          [_vm._v("Book a Call")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-wrapper" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Bulk Custom Gifting")]),
      _vm._v(" "),
      _c("p", { staticClass: "subtitle" }, [
        _vm._v(
          "Out experts will design & ship 100% custom gifts & packaging with your branding"
        )
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "happybox-button white border desktop",
          attrs: { href: "/pages/submit-an-inquiry-concierge-gifting" }
        },
        [_vm._v("Request a Custom Proposal")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "legend mobile",
          attrs: { href: "/pages/submit-an-inquiry-concierge-gifting" }
        },
        [_vm._v("Request a Custom Proposal >")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "title-container" }, [
      _c("span", { staticClass: "title" }, [_vm._v("Curated Gift Sets")]),
      _vm._v(" "),
      _c("span", { staticClass: "subtitle" }, [
        _vm._v("Expertly curated gifts, each with a handwritten note")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-header" }, [
      _c("p", { staticClass: "title-container" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Build a Gift Box")]),
        _vm._v(" "),
        _c("span", { staticClass: "subtitle" }, [
          _vm._v("Themed gift items to create custom gift from scratch")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-header" }, [
      _c("p", { staticClass: "title-container" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Gift of Choice")]),
        _vm._v(" "),
        _c("span", { staticClass: "subtitle" }, [
          _vm._v(
            "We've curated the perfect collection of gifts for them to choose from"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }